import { fetchCountryList } from "../repositories/country.repository";
import { CountryModel } from "../types/common";
import { useQuery } from "@tanstack/react-query";

export const useCountries = () => {
  return useQuery<CountryModel[]>({
    queryKey: ["countries"],
    queryFn: fetchCountryList,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours (optional)
  });
};
